import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'connected-react-router';
import './Intake.css';
import { ROUTE_NAME, ROUTE_PATH } from 'utils/constants/router';
import { INTAKE_POPUP_ACTION_SOURCE } from 'utils/constants/actionSource';
import { useNotSureAnsweredQuestions } from 'modules/intake/useNotSureAnsweredQuestions';
import { getCleanedTreatments } from 'modules/user/treatmentsQuestionHelpers';
import { Intake } from 'new-ui/Components/Intake/Intake';
import { PopupContent, PopupTitle } from 'new-ui/Components/Popup';
import app from 'new-ui/app';

// can be accessed from url
// for e.g.
// /dashboard/results?popup=intake&popup_data=%7B%22part%22%3A%22cancer%22%7D
const IntakePopup = ({ part, closePopup }) => {
  const { data: user } = useSelector((state) => state.profile);
  const dispatch = useDispatch();

  const [notSureAnsweredQuestions, setNotSureAnsweredQuestions] = useNotSureAnsweredQuestions();

  const handleUpdate = ({ user: nextUser, notSureAnsweredQuestions: nextNotSureAnsweredQuestions }) => {
    setNotSureAnsweredQuestions(nextNotSureAnsweredQuestions);
    const clonedUser = window.structuredClone(nextUser);
    clonedUser.condition_profile.treatments = getCleanedTreatments(nextUser.condition_profile.treatments);
    app.handleUserUpdate({ data: clonedUser, actionSource: INTAKE_POPUP_ACTION_SOURCE });
  };

  return (
    <div className="intake-popup">
      <PopupTitle title="About You" />
      <PopupContent>
        <Intake
          user={user}
          section={part}
          id="intakePopup"
          gotoResults={() => {
            closePopup();
            dispatch(push(ROUTE_PATH[ROUTE_NAME.RESULTS]));
          }}
          onUpdate={handleUpdate}
          notSureAnsweredQuestions={notSureAnsweredQuestions}
        />
      </PopupContent>
    </div>
  );
};

IntakePopup.propTypes = {
  part: PropTypes.string,
  closePopup: PropTypes.func.isRequired,
};

export default IntakePopup;
